import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

/**
 * Current user profile and Spring authorities from call-center backend.
 * @returns {Promise<{ userId: number, email: string, name: string, role: string, authorities: string[] }>}
 */
export const getSecurityMe = async () => {
  const envelope = await requestCallCenter({
    method: "get",
    url: "security/me",
  });
  return unwrapEnvelopeValue(envelope, "Failed to load security profile");
};

export const updateSecurityProfile = async ({ name, email }) => {
  const envelope = await requestCallCenter({
    method: "patch",
    url: "security/me",
    data: { name, email },
  });
  return unwrapEnvelopeValue(envelope, "Failed to update profile");
};

export const changeSecurityPassword = async ({ currentPassword, newPassword }) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: "security/me/change-password",
    data: { currentPassword, newPassword },
  });
  return unwrapEnvelopeValue(envelope, "Failed to change password");
};
